<h1 mat-dialog-title>Vuoi realizzare tu questo itinerario?</h1>

<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="Dettagli">
      <mat-list>
        <mat-list-item>
          <h4 mat-line>
            <b>Destinazione</b>
          </h4>
          <p mat-line>
            <small>
              {{ data.cart.destination }}
            </small>
          </p>
        </mat-list-item>
        <mat-list-item>
          <h4 mat-line>
            <b>Numero Giorni</b>
          </h4>
          <p mat-line>
            <small>
              {{ data.cart.nDays }}
            </small>
          </p>
        </mat-list-item>
        <mat-list-item>
          <h4 mat-line>
            <b>Piano</b>
          </h4>
          <p mat-line>
            <small>
              {{ data.cart.plan | uppercase }}
            </small>
          </p>
        </mat-list-item>
        <mat-list-item>
          <h4 mat-line>
            <b>Compensi</b>
          </h4>
          <p mat-line>
            <small [ngClass]="{ striked: data.proposal.test }">
              {{ data.proposal.fee | number: "1.2-2" }} €
            </small>
            <b style="color: red" *ngIf="data.proposal.test">TEST</b>
          </p>
        </mat-list-item>
      </mat-list>
    </mat-tab>
    <mat-tab label="Form 1"
      ><app-typeform-response-renderer
        *ngIf="data.cart.typeform1?.data"
        [response]="data.cart.typeform1.data"
      ></app-typeform-response-renderer
    ></mat-tab>
    <mat-tab label="Form 2"
      ><app-typeform-response-renderer
        *ngIf="data.cart.typeform2?.data"
        [response]="data.cart.typeform2.data"
      ></app-typeform-response-renderer
    ></mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions *ngIf="!loading">
  <span fxFlex></span>
  <button
    class="proposal-button"
    mat-raised-button
    color="primary"
    (click)="answer(true)"
  >
    Accetta
  </button>
  <span>&nbsp;</span>
  <button
    class="proposal-button"
    mat-raised-button
    color="warn"
    (click)="answer(false)"
  >
    Rifiuta
  </button>
  <span fxFlex></span>
</div>
<div *ngIf="loading">
  <p style="text-align: center">...operazione in corso...</p>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
